export default "__VITE_ASSET__OfkDzaxt__"